import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import NumberProps from "../NumberProps";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export const NumbersDayRoutes = () => {
  const { id, shortToken , mode } = useParams();
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent, componentProperty } = useContext(DashboardContext);
  const { hasShortToken} = useContext(AuthContext);
  
  const [routes, setRoutes] = useState<{ count: number }>({ count: 0 });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  let routeRoutes: string;

  if (hasShortToken) {
    routeRoutes = `/routes?graphic_id=numbersDayRoutes&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes?graphic_id=numbersDayRoutes&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: { data: { count: number } }) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="numbers-day-routes" className="w-100">
      <NumberProps
        value={routes}
        title="Rotas"
        id="numbers-day-routes"
        clickable={componentProperty({
          id: "numbersDayRoutes",
          property: "redirect",
        })}
        scale={3.5}
      />
    </div>
  ) : (
    <></>
  );
};
